// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TjfV","right":"styles_right__6Gx7p"};